


























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// types
import { Folder } from "@/services/folders/types";
import { Acl, ResourceClaim, ResourceType } from "@/services/security/types";
import { userGroupMediaLibAclFields } from "@/components/users/fields/userGroupMediaLibAclFields";

// components
import SelectMediaFolderModal from "@/components/files/modals/SelectMediaFolderModal.vue";
import UserAclDeleteModal from "@/components/users/modals/UserAclDeleteModal.vue";
import FolderAlreadySelectedModal from "@/components/users/modals/FolderAlreadySelectedModal.vue";

@Component({
    components: {
        SelectMediaFolderModal,
        UserAclDeleteModal,
        FolderAlreadySelectedModal
    }
})
export default class UserGroupMediaLibraryACL extends Vue {
    @Prop() acl!: Acl[];
    @Prop() collapseState!: boolean;

    // local state
    localCollapseState = true;
    localAcl = [] as Acl[];
    fields = userGroupMediaLibAclFields;
    searchQuery = "";
    resourceClaim = ResourceClaim;
    resourceType = ResourceType;

    mounted() {
        this.localCollapseState = this.collapseState;
    }

    @Watch("acl")
    onPropertyChanged(value: boolean, oldValue: any) {
        this.localAcl = this.acl.filter(x => x.type === "Folder");
    }

    // computed
    get filteredData() {
        return this.localAcl && this.localAcl
            .filter(x => this.searchQuery.length === 0 ||
                (x.name.toLowerCase().includes(this.searchQuery.toLowerCase())));
    }

    // methods
    openModal() {
        (this.$refs.selectMediaFolderModal as any).open();
    }

    folderSelected(folder: Folder) {
        var model = { resourceId: folder.id, name: folder.path, claim: this.resourceClaim.Access, type: this.resourceType.Folder } as Acl;
        if (this.localAcl.some(x => x.resourceId === model.resourceId)) {
            (this.$refs.folderAlreadySelected as any).open(model.name);
            return;
        };
        this.localAcl.unshift(model);
    }

    removeAccess(id: string, name: string) {
        (this.$refs.deleteAclModal as any).open(id, name);
    }

    onDelete(id: string) {
        const item = this.localAcl.find(x => x.resourceId === id);
        if (!item) {
            return;
        }
        this.localAcl.splice(this.localAcl.indexOf(item), 1);
    }

    emitData() {
        this.$emit("aclUpdated", this.localAcl);
    }

    setState(state: boolean) {
        if (this.localCollapseState === state) return;

        this.localCollapseState = state;
        this.$emit("componentStateChanged", { name: "UserGroupMediaLibraryACL", state: state });
    }
}
